<template>
  <div class='modal-container'>
    <div class='modal-header fl'>
      <h3>{{ 'report-of-sickness.modals.delete-report-of-sickness-confirmation-title' | translate }}</h3>
    </div>

    <div class='modal-body hf'>
      <span>{{ warningMessage }}</span>
    </div>

    <div class='modal-footer'>
      <div class='fl' style='float: right;'>
        <Button gray  @click="this.handleClose" class='mr-3'>{{ 'buttons.cancel' | translate }}</Button>
        <Button error @click="this.handleConfirm">{{ 'report-of-sickness.modals.delete-report-of-sickness-confirmation-title' | translate }}</Button>
      </div>
      <div style="clear: both;" />
    </div>
  </div>
</template>

<script>
import Helpers from '@/shared/helpers/functions';
import Modal from '@/shared/constants/modal';
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import ReportsOfSickness from '@/resources/constants/reports-of-sickness';
// START HERE
export default {
  name: 'DeleteReportOfSicknessConfirmation',
  components: {
    Button
  },
  props: {
    modalData: null
  },
  methods: {
    handleClose () {
      this.$store.dispatch(Modal.Actions.CLOSE);
    },
    handleConfirm () {
      this.$store.dispatch(ReportsOfSickness.Actions.Delete.START, this.modalData.reportOfSickness)
        .then(this.$store.dispatch(Modal.Actions.CLOSE));
    }
  },
  computed: {
    warningMessage () {
      return this.$t('report-of-sickness.modals.delete-report-of-sickness-confirmation-text')
        .replace('[[employee.name]]', this.modalData.employee.getFullName())
        .replace('[[report-of-sickness.first-of-absence]]', Helpers.Dates.formatDate(this.modalData.reportOfSickness.firstOfAbsence));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
